<script>
import LoggedIn from "./Components/Auth/LoggedIn.svelte";

import Customer from "./Components/Customer.svelte";

import Customers from "./Components/Customers.svelte";
import Documents from "./Components/Documents.svelte";
import { user } from "./store";

let customer  = "" 
</script>
<LoggedIn/>
{#if $user.loggedIn}
<div class="section_wrapper">
   
        <Customer bind:customer={customer}/>
    <div class="s s33 box">
        <div class="content_area">
        <Customers bind:customer={customer}>
            <slot>Loading Customers ....</slot>
        </Customers>
        </div>
    </div>

        <div class="s s66 box">
            <div class="content_area">
                <Documents bind:customer={customer}>
                    <slot>Select a customer first</slot>
                </Documents>
            </div>
        </div>
        
    
    
</div>
{/if}
